<template lang='pug'>
div
	span {{$t('sale.carnet_solution_services.select', 'Seleziona un servizio')}}
	v-select(
		v-model="booking.carnet.selectedService"
		variant="solo"
		:hint="'*' + $t('common.required_field', 'Campo obbligatorio')"
		:items="selectList" item-title="label" item-value="serviceId"
		return-object single-line
		:label="$t('form_labels.select_a_profile', 'Seleziona un profilo') + '*'"
		class="emd:tw-w-full tw-w-1/4"
	)
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useBookingStore} from "@/stores/booking";
import {useI18n} from "vue-i18n";


const props = defineProps({
	catalogServices: {
		type: Object,
		default: {}
	},
	offeredServices: {
		type: Object,
		default: {}
	},
	solutionId: String
});
const selectList = ref([]);
const booking = useBookingStore();
const i18n = useI18n();

onMounted(() => {
	let first = false;
	for (let osk in props.offeredServices) {
		if (!Object.hasOwnProperty.call(props.offeredServices, osk)) continue;

		let serviceId = props.offeredServices[osk].catalogServiceId;
		let label = props.catalogServices[serviceId].display_name;
		// TODO: INSERIRE MANUALMENTE PER OGNI TRADUZIONE PRESENTE NEL DB (ATTUALMENTE SOLO IT E EN), SENNÒ RITORNERÀ LA FRASE COME NEGLI ESEMPI DI SEGUITO
		label = label.replace('PRENOTAZIONE CARNET ', '');	// TRASFORMA "PRENOTAZIONE CARNET 10 TRAVEL AV" IN "10 TRAVEL AV"
		label = label.replace('BOOKING CARNET ', '');		// TRASFORMA "BOOKING CARNET 10 TRAVEL AV" IN "10 TRAVEL AV"

		selectList.value.push({
			label: label,
			serviceId: props.offeredServices[osk].id,
			solutionId: props.solutionId
		});

		if (!first) {
			booking.carnet.selectedService = {
				label: label,
				serviceId: props.offeredServices[osk].id,
				solutionId: props.solutionId
			}
			first = true;
		}
	}
});
</script>

<style scoped lang="scss">
img {
  height: 0.65rem;
  margin-right: 3px;
}

.card-solutions{
	small{
		font-size: 12px;
		line-height: 12px;
		margin: 0;
		padding: 0;
	}
	.v-card__title > div {
		line-height: normal;
		width: 20%;
	}
}

.card-solutions .v-card__text {
  color: #000000;
  font-size: 1.25rem;
  font-weight: 500;
}

/*.card-solutions .v-card__text > .row:first-child > .col {*/
/*  padding-bottom: 0;*/
/*}*/
/**/
/*.card-solutions .v-card__text > .row:last-child > .col {*/
/*  padding-top: 0;*/
/*}*/

.card-solutions .v-card__text > div > span:not(.prezzo) {
  color: #80CBC4;
}

.prezzo {
  cursor: pointer;
}

.prezzo > span {
  color: #E53935;
  font-weight: 600;
}

.solution-message {
  background-color: #FFE0B2;
  color: #E65100;
}

.v-card--disabled {
	background-color: #f2f2f2;
}

.mdi.mdi-cart-off {
	font-size: 35px;
	margin-right: 20%;
}
</style>
